import { render, staticRenderFns } from "./WorkspaceAcceptInvite.vue?vue&type=template&id=61f9d052&scoped=true&lang=pug&"
import script from "./WorkspaceAcceptInvite.vue?vue&type=script&lang=js&"
export * from "./WorkspaceAcceptInvite.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceAcceptInvite.vue?vue&type=style&index=0&id=61f9d052&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f9d052",
  null
  
)

export default component.exports